<template>
  <div>
    <div class="main_dialog dialog-scroll-small">
      <el-dialog
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose"
        @open="handleDialogOpen"
        :title="$t('label.system.meetingRoom.edit.smartSelect')"
      >
        <!-- 检索結果 開始 -->
        <div class="search-result-wrapper m-bottom-5">
          <el-checkbox-group v-model="selectedSecurityDevices">
            <el-checkbox
              v-for="item in securityDeviceSelectOptions"
              :label="item"
              :key="item.slId"
              size="small"
              class="aircon-popup-checkbox">
              <div>
                {{ item.slName }}
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <!-- 检索結果 終了 -->
        <el-row class="text-center">
          <sp-smart-button
            class="setup-button-with"
            @click="savsSecurityDevice">
            {{ $t("button.common.data.setup") }}
          </sp-smart-button>
        </el-row>
      </el-dialog>
    </div>

    <div>
      <el-dialog-prompt
        class="prompt-div"
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>
      <el-dialog-prompt
        class="prompts-div"
        :centerDialogVisibleParam.sync="errorMsgVisibleIsShow"
        :msgParam="errorMsg">
      </el-dialog-prompt>
    </div>
  </div>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt";
import statusErrorCodeMsg from "@/utils/status-error-msg";
import SpSmartButton from "@/components/common/sp-smart-button";

const EVENT_ON_SELECTED = "on-selected";

export default {
  components: {
    SpSmartButton: SpSmartButton,
    elDialogPrompt: elDialogPrompt
  },
  name: "AirConSearchPopup",
  props: {
    areaId: String, // エリアID
    fixedDeskId: String, // 指定席ID
    meetingRoomId: String, // 会議室ID
    buildingId: String, // ビルID
    floor_id: Number, // フロアID
    visible: Boolean, //
    airconList: Array, // デバイスのリスト
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
    },
  },

  data: function () {
    return {
      msgParam: this.$t("message.common.validation.settingMessage",{
        field: this.$t("label.system.meetingRoom.edit.smartNameRelation"),
      }),
      errorMsg: this.$t("message.common.searchError"),
      centerDialogVisibleIsShow: false,
      errorMsgVisibleIsShow: false,
      query: {
        areaId: null,
        buildingId: null,
      },
      searchResult: {
        airconList: [],
      },
      selectedSecurityDevices: [],
      securityDeviceSelectOptions: [],
      deviceIds: [],
      dialogVisible: this.visible,
      title: null,
    };
  },
  methods: {
    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
    savsSecurityDevice: function () {
      let deviceList = []
      for (let i = 0; i < this.selectedSecurityDevices.length; i++) {
        deviceList.push(this.selectedSecurityDevices[i].slId);
        this.deviceIds = [...new Set(deviceList)]
      }
      this.centerDialogVisibleIsShow = true
    },
    //保存成功Message
    saveSuccess: function () {
      this.$messageIotSuccess(this.$t("message.common.settingSuccess", {
        field: this.$t("label.system.meetingRoom.edit.smartName"),
      }));
    },
    handleDialogOpen: function () {
      SystemManageApi.searchSmartLock({
        buildingId: this.buildingId,
        floorId: 0,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then((resp) => {
        this.searchResult.airconList = resp.data.body;
        if (this.searchResult.airconList.length == 0) {
          this.errorMsgVisibleIsShow = true
          this.handleDialogClose();
        } else {
          this.selectedSecurityDevices = [];
          this.securityDeviceSelectOptions = [];

          for (let i = 0; i < this.searchResult.airconList.length; i++) {
            let aircon = this.searchResult.airconList[i];
            this.securityDeviceSelectOptions.push(aircon);
            if( this.airconList != null || this.airconList != undefined ) {
              if (this.airconList.indexOf(aircon.slId) >= 0) {
                this.selectedSecurityDevices.push(aircon);
              }
            }
          }

          for (let j = 0; j < this.airconList.length; j++) {
            for (let g = 0; g < this.securityDeviceSelectOptions.length; g++) {
              if( this.airconList[j].id == this.securityDeviceSelectOptions[g].slId ) {
                let securityDeviceSelectOptions = this.securityDeviceSelectOptions[g]
                this.selectedSecurityDevices.push(securityDeviceSelectOptions)
              }
            }
          }
        }
      });
    },
    isPassParam(param){
      if(param){
        if (this.meetingRoomId) {
          SystemManageApi.updateMeetingRoomAndSLRelation(
            this.meetingRoomId,
            this.deviceIds,
          )
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({data}) => {
              if(statusErrorCodeMsg(data.statusCode, this)) {
                this.saveSuccess();
                this.dialogVisible = false;
                this.$emit(EVENT_ON_SELECTED, this.selectedSecurityDevices);
                this.$emit("update:visible", false);
              }
            })
            .finally(() => {});
        } else if (this.fixedDeskId) {
          SystemManageApi.updateFixDeskAndSLRelation(
            this.fixedDeskId,
            this.deviceIds
          )
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({data}) => {
              if(statusErrorCodeMsg(data.statusCode, this)) {
                this.saveSuccess();
                this.dialogVisible = false;
                this.$emit(EVENT_ON_SELECTED, this.selectedSecurityDevices);
                this.$emit("update:visible", false);
              }
            })
            .finally(() => {});
        } else {
          SystemManageApi.updateAreaAndSLRelation(
            this.areaId,
            this.deviceIds
          )
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({data}) => {
              if(statusErrorCodeMsg(data.statusCode, this)) {
                this.saveSuccess();
                this.dialogVisible = false;
                this.$emit(EVENT_ON_SELECTED, this.selectedSecurityDevices);
                this.$emit("update:visible", false);
              }
            })
            .finally(() => {});
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-message-box{
  background-color: red !important;
}
.prompt-div >.logout-style{
  ::v-deep .el-dialog {
    height: 164px !important;
    border-radius: 3px !important;
  }
}
.prompts-div >.logout-style{
  ::v-deep .el-dialog {
    height: 164px !important;
    border-radius: 3px !important;
  }
}
.prompts-div {
  ::v-deep .cancel {
    display: none;
  }
}
.aircon-popup-checkbox {
  display: block;
  font-size: 12px;
}

.title {
  margin-left: 98px;
  font-size: 30px;
  font-weight: bold;
  color: #7f7f7f;
}
.main_dialog {
  ::v-deep .el-dialog__header .el-dialog__headerbtn {
    //display: none;
  }
  ::v-deep .el-dialog {
    border-radius: 3px;
  }
  ::v-deep .el-dialog__body {
    padding-top: 0;
    padding-left: 28px;
    padding-bottom: 0;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
}
.el-checkbox {
  margin-bottom: 20px;
}
.button_box {
  align-items: center;
}
::v-deep .el-checkbox__inner {
  margin-top: 5px;
  margin-left: 5px;
}
.setup-button-with {
  width: 292px;
}
</style>
